import { FaPhone, FaEnvelope, FaMapMarkerAlt } from 'react-icons/fa';
import { trackContactClick } from '../utils/metaPixel';

const Footer = () => {
  const handleContactClick = (type) => {
    trackContactClick(type);
  };

  return (
    <footer className="bg-[#1e253f] text-white">
      <div className="max-w-6xl mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {/* School Description */}
          <div>
            <h3 className="text-xl font-bold mb-4">À propos de l'ENSAM Casablanca</h3>
            <p className="text-slate-300 text-sm leading-relaxed mb-6">
              L'ENSAM de Casablanca est une école d'ingénieurs qui a pour mission de préparer 
              les étudiants-ingénieurs aux métiers du secteur industriel.
            </p>
          </div>

          {/* Contact Information */}
          <div>
            <h3 className="text-xl font-bold mb-4">Contact</h3>
            <div className="space-y-4">
              <div className="flex items-start space-x-3">
                <FaMapMarkerAlt className="text-[#63B3ED] w-5 h-5 mt-1 flex-shrink-0" />
                <p className="text-slate-300 text-sm">
                  50 Avenue Nile Sidi Othman, Casablanca 20670
                </p>
              </div>

              <div className="flex items-center space-x-3">
                <FaPhone className="text-[#63B3ED] w-5 h-5 flex-shrink-0" />
                <a 
                  href="tel:+212679791682" 
                  onClick={() => handleContactClick('phone')}
                  className="text-slate-300 text-sm hover:text-[#63B3ED] transition-colors"
                >
                  06 79 79 16 82
                </a>
              </div>

              <div>
                <div className="flex items-center space-x-3 mb-2">
                  <FaEnvelope className="text-[#63B3ED] w-5 h-5 flex-shrink-0" />
                  <p className="text-slate-300 text-sm">Responsable: Hamlich Mohamed</p>
                </div>
                <a 
                  href="mailto:mohamed.hamlich@ensam-casa.ma"
                  onClick={() => handleContactClick('email')}
                  className="text-slate-300 text-sm hover:text-[#63B3ED] transition-colors ml-8"
                >
                  mohamed.hamlich@ensam-casa.ma
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* Copyright */}
        <div className="border-t border-slate-800 mt-12 pt-8">
          <p className="text-center text-slate-400 text-sm">
            © {new Date().getFullYear()} ENSAM Casablanca. Tous droits réservés.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;